export const BEACHES_SCHEMA = [
  {
    field: 'name',
    label: 'Nombre',
  },
  {
    field: 'province',
    label: 'Provincia',
  },
  {
    field: 'town',
    label: 'Municipio',
  },
  {
    field: 'blueFlag',
    label: 'Bandera azul',
    centered: true,
  },
  {
    field: 'hasDisabledAccess',
    label: 'Acceso personas con discapacidad',
    centered: true,
  },
];
